import React from 'react'

import PropTypes from 'prop-types'

import { Container, Box } from '@mui/material'
import { darkTheme, lightTheme } from 'themes/theme'
import PdsHeader from 'components/Headers/PdsHeader'
import Footer from 'components/Footer/Footer'
import AcceptFooter from 'components/Footer/AcceptFooter'
import { useDynamicManageStore } from 'store/useDynamicManageStore'
import { MAX_CONTAINER_WIDTH, IS_NEW_LAYOUT_ENABLED, NEW_CONTAINER_WIDTH } from 'constants/layoutConstant'
function PdsLayout({ theme, children }) {
    const useTheme = theme === 'dark' ? darkTheme : lightTheme
    const { isStatusAccepted, isStatusPending } = useDynamicManageStore((state) => state)

    return (
        <Box
            sx={{
                position: 'relative'
            }}
        >
            <PdsHeader />
            <Box
                className="pds__container"
                backgroundColor={IS_NEW_LAYOUT_ENABLED ? 'background.default' : 'background.paper'}
            >
                <Container
                    className="pdf__container"
                    disableGutters
                    sx={{
                        backgroundColor: useTheme.palette.background.default,
                        display: 'grid',
                        gap: 6,
                        maxWidth: IS_NEW_LAYOUT_ENABLED
                            ? { lg: NEW_CONTAINER_WIDTH }
                            : { md: 837, lg: MAX_CONTAINER_WIDTH },
                        px: IS_NEW_LAYOUT_ENABLED ? { xs: 1, md: 14, lg: 14 } : { xs: 1, md: 15, lg: 9 },
                        py: IS_NEW_LAYOUT_ENABLED ? { xs: 0 } : { xs: 12, md: 15 },
                        pb: IS_NEW_LAYOUT_ENABLED ? { xs: 6, md: 12 } : 0,
                        wordBreak: 'break-word'
                    }}
                >
                    {children}
                </Container>
            </Box>
            {isStatusPending() && <Footer />}
            {IS_NEW_LAYOUT_ENABLED && isStatusAccepted() && <AcceptFooter />}
        </Box>
    )
}

PdsLayout.propTypes = {
    theme: PropTypes.string,
    children: PropTypes.node
}

export default PdsLayout
